module.exports = __webpack_public_path__ + "static/img/3.ac7adb9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/publish/3.png
// module id = CkOI
// module chunks = 1